import { render, staticRenderFns } from "./menuManage.vue?vue&type=template&id=4e5c9933&scoped=true"
import script from "./menuManage.vue?vue&type=script&lang=js"
export * from "./menuManage.vue?vue&type=script&lang=js"
import style0 from "./menuManage.vue?vue&type=style&index=0&id=4e5c9933&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c9933",
  null
  
)

export default component.exports